import { AlertColor, SnackbarCloseReason } from '@mui/material';
import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MessageContextType {
    open: boolean;
    message: string;
    severity: AlertColor;
    showMessage: (message: string, severity: AlertColor) => void;
    handleClose: (event: React.SyntheticEvent | Event, reason: SnackbarCloseReason) => void;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const useMessage = () => {
    const context = useContext(MessageContext);
    if (context === undefined) {
        throw new Error('useMessage must be used within a MessageProvider');
    }
    return context;
};

export const MessageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState<AlertColor>('success');

    const showMessage = (message: string, severity: AlertColor) => {
        setMessage(message);
        setSeverity(severity);
        setOpen(true);
    };

    const handleClose = (event: React.SyntheticEvent | Event, reason: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <MessageContext.Provider value={{ open, message, severity, showMessage, handleClose }}>
            {children}
        </MessageContext.Provider>
    );
};
